import { Talent } from '../../Classes'

export default [
  null,
  new Talent(
    'Bestial Wrath',
    'ability_druid_ferociousbite',
    ['Send your pet into a rage causing 50% additional damage for 18 sec. While enraged, the beast does not feel pity or remorse or fear and it cannot be stopped unless killed.'],
    1,
    [[]],
    [{ x: 4, y: 1 }],
    null,
    '12% of base mana',
    '100 yd range',
    'Instant',
    '2 min cooldown'
  ),
  null,
  null,
]
